const React=require('react');
function NumberBalls({number,allowPick5=false}){
 if(typeof number!=='string'||!(allowPick5?/^\d{3,5}$/:/^\d{3,4}$/).test(number))return null;
 return React.createElement('span',{className:'lotto-balls','aria-label':number},...number.split('').map((digit,i)=>React.createElement('span',{className:'lotto-ball',key:i,'aria-hidden':'true'},digit)));
}
module.exports=NumberBalls;
